import { hsl } from 'polished';
export default {
    /** Hex: #333333 */
    black: '#333333',
    /** Hex: #000 */
    fullBlack: '#000',
    /** Hex: #fff */
    white: '#fff',
    primary: {
        /** Hex: #FF1932 */
        red: '#FF1932',
        /** Hex: #D1D2D3 */
        grey: '#D1D2D3',
    },
    secondary: {
        /** Hex: #E6054B */
        red1: '#E6054B',
        /** Hex: #D20037 */
        red2: '#D20037',
        /** Hex: #B42855 */
        red3: '#B42855',
        /** Hex: #A00037 */
        red4: '#A00037',
        /** Hex: #87284B */
        red5: '#87284B',
    },
    buff: {
        /** Hex: #FEEFE0 */
        buff1: '#FEEFE0',
        /** Hex: #FFFFE6 */
        buff2: '#FFFFE6',
        /** Hex: #FFEBDC */
        buff3: '#FFEBDC',
        /** Hex: #FFB9A0 */
        buff4: '#FFB9A0',
    },
    tertiary: {
        /** Hex: #0476DC */
        blue: '#0476DC',
        /** Hex: #F4F6F8 */
        buff: '#F4F6F8',
        /** Hex: #509E7D */
        green: '#509E7D',
        /** Hex: #F1749B */
        pink: '#F1749B',
        /** Hex: #E3ACBB */
        pinkAlt: '#E3ACBB',
        /** Hex: #1F1031 */
        purple: '#1F1031',
        /** Hex: #593B91 */
        lightPurple: '#593B91',
    },
    theme: {
        /** Hex: #0476DC */
        blue: '#F4F6F8',
        /** Hex: #F4F6F8 */
        orange: '#FEEFE0',
        /** Hex: #509E7D */
        green: '#F1F7F5',
        /** Hex: #F1749B */
        pink: '#FAEEF1',
    },
    validation: {
        /** Hex: #DA291C */
        invalid: '#DA291C',
        /** Hex: #DA291C */
        valid: '#008C15',
    },
    grey: {
        /** Hex: #222222 */
        grey13: hsl(0, 0, 0.13),
        /** Hex: #585858 */
        grey20: hsl(0, 0, 0.2),
        /** Hex: #585858 */
        grey35: hsl(0, 0, 0.35),
        /** Hex: #666666 */
        grey40: hsl(0, 0, 0.4),
        /** Hex: #707070 */
        grey44: hsl(0, 0, 0.44),
        /** Hex: #999999 */
        grey60: hsl(0, 0, 0.6),
        /** Hex: #CCCCCC */
        grey80: hsl(0, 0, 0.8),
        /** Hex: #E5E5E5 */
        grey90: hsl(0, 0, 0.9),
        /** Hex: #F0F0F0 */
        grey94: hsl(0, 0, 0.94),
        /** Hex: #F7F7F7 */
        grey97: hsl(0, 0, 0.97),
    },
};
